import { Button, Unform, AddObservation, SelectInput } from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useCallback, useContext } from 'react';
import { Flex, Box, Stack } from '@chakra-ui/react';
import { SubmitHandler } from '@unform/core';
import { evaluationCtx } from '../../index';
import { checkPermission } from 'utils/authentication';

import Evaluation from 'models/Forms/Evaluation';

interface IProps extends BodyProps {}

const TreatmentAspectsComponent: React.FC<IProps> = ({
  index,
  functionCallback,
  submit,
  completed,
}) => {
  const ctx = useContext(evaluationCtx);
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleChangePayload = useCallback((index: string, ...args: any) => {
    const e = args[1] || args[0];
    const value = e.target.value;
    if (args[1] && typeof args[0] === 'boolean') {
      ctx.handlePayload(prevState => {
        const dt = JSON.parse(JSON.stringify(prevState)) as Evaluation;
        dt.jsonCustomObsObj[index] = value;
        return dt;
      });
    } else {
      ctx.handlePayload(prevState => {
        const dt = JSON.parse(JSON.stringify(prevState)) as Evaluation;
        // @ts-ignore
        dt[index] = value;
        return dt;
      });
    }
  }, []);

  const inputs = [
    {
      props: {
        label: 'O projeto combina várias fontes de dados pessoais?',
        name: 'combinesMultipleSourcesOfPersonalData',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(null, 'combinesMultipleSourcesOfPersonalData', true),
    },
    {
      props: {
        label: 'O projeto envolve o tratamento de dados pessoais em larga escala?',
        name: 'largeScaleProcessingOfPersonalData',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(null, 'largeScaleProcessingOfPersonalData', true),
    },
    {
      props: {
        label:
          'Os dados pessoais utilizados são os mínimos necessários para atingir às finalidades?',
        name: 'personalDataUsedAreMinimumNecessaryAchievePurposes',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(
        null,
        'personalDataUsedAreMinimumNecessaryAchievePurposes',
        true,
      ),
    },
    {
      props: {
        label:
          'Houve determinação de período de retenção dos dados pessoais coletados para fins do projeto?',
        name: 'personalDataCollectedForPurposesOfProject',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(
        null,
        'personalDataCollectedForPurposesOfProject',
        true,
      ),
    },
    {
      props: {
        label: 'Os dados pessoais envolvidos são obtidos diretamente da pessoa física?',
        name: 'directlyFromTheIndividual',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(null, 'directlyFromTheIndividual', true),
    },
    {
      props: {
        label: 'O projeto envolve envio de dados para o exterior?',
        name: 'sendingDataAbroad',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(null, 'sendingDataAbroad', true),
    },
    {
      props: {
        label: 'A tecnologia envolvida no projeto pode ser considerada inovadora?',
        name: 'innovativeTechnology',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(null, 'innovativeTechnology', true),
    },
    {
      props: {
        label: 'O projeto envolve tomada de decisão automatizada (sem intervenção humana)?',
        name: 'automatedDecision',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(null, 'automatedDecision', true),
    },
    {
      props: {
        label:
          'O projeto envolve acompanhar, supervisionar ou de alguma forma monitorar pessoas físicas?',
        name: 'monitoringTndividuals',
        placeholder: 'Selecione',
      },
      onChangeEvent: handleChangePayload.bind(null, 'monitoringTndividuals', true),
    },
  ];

  const handleSubmit = useCallback<SubmitHandler<Evaluation>>(
    async data => {
      setLoading(true);
      if (submit) {
        const resp = await submit(data, '4 - Aspectos do tratamento');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [functionCallback],
  );

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={treatmentAspectsValidationSchema}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            {inputs.map((value, index) => {
              return (
                <Box key={index}>
                  <SelectInput
                    {...value.props}
                    mt="20px"
                    mb="10px"
                    options={[
                      { label: 'Sim', value: 'yes' },
                      { label: 'Não', value: 'no' },
                    ]}
                  />
                  <AddObservation
                    // @ts-ignore
                    placeholder={''}
                    marginTop="0px"
                    marginBottom="30px"
                    onChangeEvent={value.onChangeEvent}
                    obsValue={ctx.data.jsonCustomObsObj[value.props.name]}
                  />
                </Box>
              );
            })}
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            {inputs.map((value, index) => {
              return (
                <Box key={index}>
                  <SelectInput
                    {...value.props}
                    mt="20px"
                    mb="10px"
                    options={[
                      { label: 'Sim', value: 'yes' },
                      { label: 'Não', value: 'no' },
                    ]}
                    isDisabled={completed}
                  />
                  <AddObservation
                    isDetail={completed}
                    // @ts-ignore
                    placeholder={''}
                    marginTop="0px"
                    marginBottom="30px"
                    onChangeEvent={value.onChangeEvent}
                    obsValue={ctx.data.jsonCustomObsObj[value.props.name]}
                  />
                </Box>
              );
            })}
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const TreatmentAspects = memo(TreatmentAspectsComponent);
